import { Anchor } from '@mantine/core'
import { useNavigate } from 'react-router-dom';

import classes from './index.module.css';

interface IFooterAnchor {
    text: string,
    href: string,
}

const FooterAnchor = ({ href, text }: IFooterAnchor) => {
    const navigate = useNavigate();

    return <Anchor onClick={() => navigate(href)} className={classes.anchor}>{text}</Anchor>
}

export default FooterAnchor;